import { render, staticRenderFns } from "./activity_tp_list.vue?vue&type=template&id=a74ca8a8&scoped=true"
import script from "./activity_tp_list.vue?vue&type=script&lang=js"
export * from "./activity_tp_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74ca8a8",
  null
  
)

export default component.exports